import {
  BorderOutlined,
  CheckOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  PauseCircleOutlined,
  MinusOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { ReactNode } from "react";

interface LegendItem {
  title: string;
  icon: ReactNode;
  tooltip: string;
}

export const statusTableLegend: LegendItem[] = [
  {
    title: "Administered",
    icon: (
      <CheckOutlined
        style={{
          color: "#06709B",
          backgroundColor: "#D2EFF9",
          padding: "2px",
        }}
      />
    ),
    tooltip: "Dose was fully administered.",
  },
  {
    title: "Missed",
    icon: (
      <div className="flex items-center justify-center bg-[#FAEEDF]">
        <StopOutlined
          style={{
            fontSize: "12px",
            color: "#73134A",
            backgroundColor: "#EBD1E0",
            padding: "4px",
          }}
        />
      </div>
    ),
    tooltip: "Dose was not administered.",
  },
  {
    title: "Interrupted",
    icon: (
      <PauseCircleOutlined
        style={{
          fontSize: "12px",
          color: "black",
          backgroundColor: "#FEF7DF",
          padding: "4px",
        }}
      />
    ),
    tooltip: "Dose administration was interrupted.",
  },
  {
    title: "Increased",
    icon: (
      <ArrowUpOutlined
        style={{
          color: "#004A42",
          backgroundColor: "#CAE6D6",
          border: "1px solid #D5DADC",
          padding: "2px",
          borderRadius: "2px",
        }}
      />
    ),
    tooltip: "Dose increased relative to last dose.",
  },
  {
    title: "Reduced",
    icon: (
      <ArrowDownOutlined
        style={{
          color: "#DF7934",
          backgroundColor: "#F2C9AE",
          padding: "2px",
        }}
      />
    ),
    tooltip: "Dose reduced relative to last dose.",
  },

  {
    title: "No Dose Data",
    icon: (
      <MinusOutlined
        style={{
          color: "#D5DADC",
          backgroundColor: "white",
          border: "1px solid #D5DADC",
          padding: "2px",
          borderRadius: "2px",
        }}
      />
    ),
    tooltip: "No dose data or dose not required.",
  },
];

export const administeredTableLegend: LegendItem[] = [
  {
    title: "Study Dose",
    icon: (
      <BorderOutlined
        style={{
          color: "#D2EFF9",
          backgroundColor: "#D2EFF9",
          padding: "2px",
        }}
      />
    ),
    tooltip:
      "Subject was administered the study dose as defined in the protocol.",
  },
  {
    title: "Lower than Study Dose",
    icon: (
      <BorderOutlined
        style={{
          color: "#F2C9AE",
          backgroundColor: "#F2C9AE",
          padding: "2px",
        }}
      />
    ),
    tooltip: "Dose administered is lower than the study dose.",
  },
  {
    title: "Higher than Study Dose",
    icon: (
      <BorderOutlined
        style={{
          color: "#EBD1E0",
          backgroundColor: "#EBD1E0",
          padding: "2px",
        }}
      />
    ),
    tooltip: "Dose administered is higher than the study dose.",
  },
  {
    title: "No Dose Data",
    icon: (
      <MinusOutlined
        style={{
          color: "#D5DADC",
          backgroundColor: "white",
          border: "1px solid #D5DADC",
          padding: "2px",
          borderRadius: "2px",
        }}
      />
    ),
    tooltip: "No dose data or dose not required.",
  },
];
